/**
 * Late-merge follow-up (PR #635 review, PRRT_kwDORS4ils6YuypX, P1) — synced from
 * packages/cli/src/lib/strip.ts's stripControlChars (BET-269 C3: terminal escaping). MCP is a
 * separate build target that cannot import packages/cli at build time (BR-25, this package's own
 * lib/README.md) — this is a same-name, same-regex sync, not an independent reimplementation.
 *
 * Strip ANSI escape sequences and control characters from workspace-controlled strings before
 * they reach MCP text content. A client that renders tool output in a terminal (many do)
 * inherits the same terminal-injection risk the CLI already guards against — a question,
 * domain, role/person name, or outcome string can carry cursor-movement/color/title-change
 * escape sequences the caller never typed.
 */

// Note: the CSI/OSC alternatives MUST precede the bare control-char class — see
// packages/cli/src/lib/strip.ts's own comment for why (regex alternation takes the first
// matching alternative at a position, not the longest).
// Late-fix consolidation round 1 (PRRT_kwDORS4ils6Y0pz3, P1): \x0b-\x1f is one contiguous
// range so a bare carriage return (\x0d) is stripped too — see packages/cli/src/lib/strip.ts's
// own comment for the terminal-injection rationale (\r moves the cursor to column zero and
// can overwrite/spoof the start of a line; \t/\n are preserved for legitimate multiline use).
// eslint-disable-next-line no-control-regex
const ANSI_AND_CONTROL_RE = /\x1b\[[0-9;]*[A-Za-z]|\x1b\][^\x07]*\x07|\x1b[^[\]0-9;A-Za-z]?|[\x00-\x08\x0b-\x1f\x7f]/g;

export function stripControlChars(str: string): string {
  if (!str) return str;
  return str.replace(ANSI_AND_CONTROL_RE, "");
}
